import AppLayout from "@/layouts/AppLayout";
import { Outlet, useLocation } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";

export default function PersonBenefitsLayout() {
  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewBeneficiaries });
  const location = useLocation();
  const isUpdateBeneficiariesPage = location.pathname.includes("/beneficiaries/update/");
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  if (shouldRenderError) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  if (isUpdateBeneficiariesPage) {
    return <Outlet />;
  }

  const renderDesktopLayout = () => (
    <>
      <PersonObjectHeading pgaId={pgaId!} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        title="Benefits"
        compactOnly
        compactTitle="Benefits"
        backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }}
      />
      <PersonObjectHeading pgaId={pgaId!} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
